import { EmbedGem, EmbedGemData } from '@/gem.types';
import ReactPlayer from 'react-player';

interface Props {
  gem: EmbedGem;
  autoPlay?: boolean;
}

const Embed = ({ gem, autoPlay }: Props) => {
  const { type, code, url } = gem as EmbedGemData;
  if (type !== 'embed') throw new Error('Not an embed gem');
  if (url) {
    return (
      <div className="mb-6 flex items-center justify-center">
        <div className="relative w-full h-0" style={{ paddingTop: '56.25%' }}>
          <ReactPlayer
            className="absolute top-0 left-0 w-full h-full"
            playsinline={true}
            playing={autoPlay}
            url={url}
            width="100%"
            height="100%"
            controls
          />
        </div>
      </div>
    );
  }

  return (
    <div className="mb-6  flex items-center justify-center">
      <div className="relative w-full h-0" style={{ paddingTop: '56.25%' }}>
        <div
          className="absolute top-0 left-0 w-full h-full"
          dangerouslySetInnerHTML={{ __html: code }}
        />
      </div>
    </div>
  );
};

export default Embed;
